#import "../../../graphql/fragments/sms-membership-stats-fragment.graphql"

fragment AudienceSmsMembershipStatsRealtime on Audience {
    id
    smsMembershipStatsRealtime {
        ...SmsMembershipStatsFragment
    }
}
